/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const HeadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const InfoContainer = styled.div({
  padding: `${token('space.250')} 0 ${token('space.050')} ${token(
    'space.050'
  )}`,
});

export const SpinnerContainer = styled.div({
  paddingLeft: token('space.050'),
  paddingRight: token('space.100'),
});

export const ErrorContainer = styled.div({
  paddingTop: token('space.250'),
});

export const LineContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: token('space.050'),
  paddingRight: token('space.050'),
});

export const ErrorMessage = styled.div({
  color: token('color.text'),
});

export const AdditionalTransitions = styled.div({
  color: token('color.text.subtlest'),
  font: token('font.body'),
});
